import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Standard} from "../../../../../models/standard.model";

@Component({
  selector: 'app-standard-action-modal',
  templateUrl: './standard-action-modal.component.html',
  styleUrls: ['./standard-action-modal.component.css']
})
export class StandardActionModalComponent implements OnInit {
  standard: Standard;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }

  setStandardForAction(stnrd) {
    this.standard = stnrd;
  }

  selectedActionWithStandard(action, notification) {
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/admin/operating-standard-list-all/modal/standard-action-modal/standard-action-modal.component.ts